(() => {
  const button = document.querySelector('.vantro-whatsapp-floating');
  if (!button || button.dataset.ready) return;
  button.dataset.ready = 'true';
  const mobile = matchMedia('(max-width: 749px)');
  let pending = false;
  const place = () => {
    pending = false;
    if (mobile.matches) return;
    // Keep the link clear of visible controls, including form actions and consent UI.
    button.style.setProperty('--wa-lift', '0px');
    button.classList.remove('is-compact');
    let base = button.getBoundingClientRect();
    button.style.pointerEvents = 'none';
    const obstacles = [...document.querySelectorAll('a,button,input,select,textarea,[role="dialog"],#shopify-pc__banner')]
      .filter(el => el !== button && !button.contains(el) && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden')
      .flatMap(el => {
        const rect = el.getBoundingClientRect();
        // Large linked media cards remain clickable around the icon; protect their text,
        // rather than treating the entire photograph as a small action button.
        if (el.tagName === 'A' && rect.height > 150) {
          const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
          const regions = [];
          while (walker.nextNode()) {
            if (!walker.currentNode.textContent.trim()) continue;
            const range = document.createRange();
            range.selectNodeContents(walker.currentNode);
            for (const textRect of range.getClientRects()) regions.push({ el, rect: textRect });
          }
          return regions;
        }
        return [{ el, rect }];
      })
      .filter(({ rect: r }) => r.width && r.height && r.bottom > 0 && r.top < innerHeight && r.left < base.right + 8 && r.right > base.left - 8);
    const blocked = lift => obstacles.some(({ el, rect: r }) => {
      const left = Math.max(r.left, base.left - 4), right = Math.min(r.right, base.right + 4);
      const top = Math.max(r.top, base.top - lift - 8), bottom = Math.min(r.bottom, base.bottom - lift + 8);
      if (left >= right || top >= bottom) return false;
      const hit = document.elementFromPoint((left + right) / 2, (top + bottom) / 2);
      return hit && (hit === el || el.contains(hit));
    });
    if (blocked(0)) {
      button.classList.add('is-compact');
      base = button.getBoundingClientRect();
    }
    let lift = 0;
    for (; lift < base.top - 80; lift += 58) {
      if (!blocked(lift)) break;
    }
    button.style.setProperty('--wa-lift', `${Math.min(lift, Math.max(0, base.top - 80))}px`);
    button.style.pointerEvents = '';
  };
  const schedule = () => { if (!mobile.matches && !pending) { pending = true; requestAnimationFrame(place); } };
  const observer = new MutationObserver(schedule);
  const configure = () => {
    removeEventListener('scroll', schedule);
    removeEventListener('resize', schedule);
    window.visualViewport?.removeEventListener('resize', schedule);
    document.removeEventListener('shopify:section:load', schedule);
    observer.disconnect();
    if (mobile.matches) {
      button.style.removeProperty('--wa-lift');
      button.classList.remove('is-compact');
      button.style.pointerEvents = '';
      return;
    }
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    schedule();
  };
  mobile.addEventListener('change', configure);
  configure();
})();
